import { CoordinatorService } from './coordinator.service';
import { Report } from './report';
import { ScriptKeyword } from './script-keyword';
import { ScriptRatings } from './script-ratings';
import { ScriptSubset } from './script-subset';
import { ScriptTags } from './script-tags';

type SUBSET_ARG = string | ScriptSubset;
type KEYWORD_ARG = string | ScriptKeyword;
type RATINGS_ARG = string | ScriptRatings;
type TAGS_ARG = string | ScriptTags;

export class ScriptReport {
    #coords: CoordinatorService;
    #_report: Report;

    constructor(coords: CoordinatorService, _report: Report) {
        this.#coords = coords;
        this.#_report = _report;
    }

    importProject() {
        const p = this.#coords.project$.current!.scriptClass;
        this.addSubsets(p.subsets);
        this.addKeywords(p.keywords);
        this.addRatings(p.ratings);
        this.addTags(p.tags);
        this.addComments();
        this.addAttachments();
    }

    addComments() {
        this.#_report.addComments('current');
    }

    addAttachments() {
        this.#_report.addAttachments('current');
    }

    addSubsets(arg: SUBSET_ARG | SUBSET_ARG[]) {
        if (!Array.isArray(arg)) arg = [arg];
        const ls: string[] = [];
        arg.forEach((s) => {
            if (s instanceof ScriptSubset) s.addToReport(this.#_report);
            else ls.push(s);
        });
        ls.length && this.#_report.addSubsets(ls);
    }

    addKeywords(arg: KEYWORD_ARG | KEYWORD_ARG[]) {
        if (!Array.isArray(arg)) arg = [arg];
        const ls: string[] = [];
        arg.forEach((kw) => {
            if (kw instanceof ScriptKeyword) kw.addToReport(this.#_report);
            else ls.push(kw);
        });
        ls.length && this.#_report.addKeywords(ls);
    }

    addRatings(arg: RATINGS_ARG | RATINGS_ARG[]) {
        if (!Array.isArray(arg)) arg = [arg];
        const ls: string[] = [];
        arg.forEach((r) => {
            if (r instanceof ScriptRatings) r.addToReport(this.#_report);
            else ls.push(r);
        });
        ls.length && this.#_report.addBinaryTree('ratings', ls);
    }

    addTags(arg: TAGS_ARG | TAGS_ARG[]) {
        if (!Array.isArray(arg)) arg = [arg];
        const ls: string[] = [];
        arg.forEach((r) => {
            if (r instanceof ScriptTags) r.addToReport(this.#_report);
            else ls.push(r);
        });
        ls.length && this.#_report.addBinaryTree('tags', ls);
    }

    save() {
        this.#_report.save();
    }

    json() {
        // return this.#_report.json()
    }

    log(prefix = 'Report') {
        console.log(`${prefix}: ${this.#_report.title}`);
        console.log(this.#_report);
        return this;
    }

    display() {
        this.#coords.script$.stage('report')?.display();
        return this;
    }
}
